import moment from "moment";
import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import {
  currencyFormatter,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
} from "../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../_metronic/_partials/controls";
import { StatusColumnFormatter } from "../billing-table/column-formatters";
import { sizePerPageList } from "../BillingUIHelpers";

export default function HistoryPayment({
  queryParams = {},
  setQueryParams,
  historyData = [],
  listLoading,
  totalCount,
}) {
  // Table columns
  const columns = [
    {
      dataField: "created_at",
      text: "Tanggal",
      formatter: (cell) => {
        return moment(cell).format("YYYY-MM-DD");
      },
    },
    {
      dataField: "invoice_hid",
      text: "Invoice ID",
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell) => {
        return StatusColumnFormatter(cell);
      },
    },
    {
      dataField: "invoice_price",
      text: "Total Pembayaran",
      classes: "text-right",
      headerClasses: "text-right",
      formatter: (cell) => {
        return currencyFormatter(cell);
      },
    },
  ];

  const columnsDetail = [
    {
      dataField: "item",
      headerClasses: "text-center",
      text: "Item",
      classes: "text-center",
      footer: "Total Biaya Tambahan:",
      footerClasses: "text-center",
      formatter: (cell) => {
        let render = "";
        switch (cell) {
          case "DONOR":
            render = "BIAYA TAMBAHAN DONATUR";

            break;
          case "USER":
            render = "BIAYA TAMBAHAN USER";
            break;
          case "PREV_INVOICE":
            render = "TAGIHAN BULAN LALU";
            break;

          default:
            break;
        }
        return <span>{render}</span>;
      },
    },
    {
      dataField: "price",
      headerClasses: "text-right",
      text: "Harga per Item",
      classes: "text-right",
      formatter: (cell) => {
        return currencyFormatter(cell);
      },
      footer: "",
      footerClasses: "text-center",
    },
    {
      dataField: "qty",
      headerClasses: "text-center",
      text: "Jumlah",
      classes: "text-center",
      footer: (cell) => {
        return cell.reduce((prev, curr) => prev + curr, 0);
      },
      footerClasses: "text-center",
    },
    {
      dataField: "total_price",
      text: "Jumlah",
      headerClasses: "text-right",
      classes: "text-right",
      formatter: (cell) => {
        return currencyFormatter(cell);
      },
      footer: (cell) => {
        const sum = cell.reduce((prev, curr) => prev + curr, 0);
        return currencyFormatter(sum);
      },
      footerClasses: "text-right",
    },
  ];

  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: sizePerPageList,
    sizePerPage: queryParams.pageSize,
    page: queryParams.pageNumber,
  };

  const expandRow = {
    renderer: (row) => {
      return (
        <>
          {/* <div className="row">
            <div className="col-lg-3"> */}
          <p>
            Paket Pembelian:{" "}
            <span className="font-weight-bolder">{row.plan.name}</span>
            <br />
          </p>
          <p>
            Status:{" "}
            <span className="ml-4">{StatusColumnFormatter(row.status)}</span>
            <br />
          </p>
          <p>
            Harga Paket:{" "}
            <span className="font-weight-bolder">
              {currencyFormatter(row.plan.price)}
            </span>
            <br />
          </p>
          {/* </div>
            <div className="col-lg-9"> */}
          <BootstrapTable
            wrapperClasses="table-responsive"
            classes="table table-head-custom table-vertical-center overflow-hidden"
            bootstrap4
            hover
            striped
            bordered={false}
            remote
            keyField="uuid"
            data={row.plan_invoice_item || []}
            columns={columnsDetail}
          />
          {/* </div>
          </div> */}
        </>
      );
    },
    showExpandColumn: true,
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      if (isAnyExpands) {
        return (
          <i
            style={{ cursor: "pointer" }}
            class="fas fa-caret-down fa-rotate-180"
          ></i>
        );
      }
      return <i style={{ cursor: "pointer" }} class="fas fa-caret-down"></i>;
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return (
          <i
            style={{ cursor: "pointer" }}
            class="fas fa-caret-down fa-rotate-180"
          ></i>
        );
      }
      return <i style={{ cursor: "pointer" }} class="fas fa-caret-down"></i>;
    },
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="uuid"
                data={historyData === null ? [] : historyData}
                expandRow={expandRow}
                columns={columns}
                onTableChange={getHandlerTableChange(setQueryParams)}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={historyData} />
                <NoRecordsFoundMessage entities={historyData} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
